<template>
  <div :class="this.isMobile.value ? 'login-backend-mobile' : 'login-backend'">
    <!-- 注册 -->
    <div class="register">
      <div class="register-step">
        <h1 style="display: inline;">重置密码</h1>
      </div>

      <!-- 注册信息 -->
      <div class="register-wrapper">
        <el-form :rules="rules" ref="form" label-width="80px" :model="form">
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item prop="userName">
                <el-input
                  class="text-input"
                  placeholder="请输入您的身份证号"
                  v-model="form.userName"
                  prefix-icon="el-icon-user-solid"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8"> <em>*</em>请输入您的身份证号</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item prop="phoneNumber">
                <el-input
                  class="text-input"
                  placeholder="手机号码"
                  v-model="form.phoneNumber"
                  prefix-icon="el-icon-phone"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8"><em>*</em>请输入平台预留手机号码</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item prop="password">
                <el-input
                  class="text-input"
                  placeholder="设置新密码"
                  v-model="form.password"
                  type="password"
                  prefix-icon="el-icon-view"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8"><em>*</em>新密码,6-20位字符</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item prop="confirmPassword">
                <el-input
                  class="text-input"
                  placeholder="密码确认"
                  v-model="form.confirmPassword"
                  type="password"
                  prefix-icon="el-icon-view"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8"><em>*</em>请再一次输入密码进行密码确认</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item prop="phoneCode">
                <el-input
                  placeholder="请输入您接收的短信验证码"
                  v-model="form.phoneCode"
                ></el-input>
                <button
                  @click.prevent="getCode()"
                  class="code-btn"
                  :disabled="!show"
                >
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show" class="count">{{ count }} s</span>
                </button>
              </el-form-item>
            </el-col>
            <el-col :span="8"><em>*</em>请注意查收短信验证码</el-col>
          </el-row>
        </el-form>
        <el-button type="danger" round class="login-button" @click="resetPassword"
          >确认重置</el-button
        >
        <el-link type="success" class="login-tip" @click="changeType"
          >去登陆</el-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { isIdentityId } from "@/utils/validate";
import { checkUserPhone, resetUserPwd } from "@/api/user";
import { sendCode } from "@/api/sms";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  name: "register",
  components: {
    Treeselect
  },
  data() {
    return {
      title: "赣州产控电子采购平台",
      active: 0,
      countTime: 0, // 倒计时
      timers: null,
      form: {
        userName: "",
        confirmUserName: "",
        fullName: "",
        password: "",
        confirmPassword: "",
        phoneNumber: "",
        phoneCode: "",
        materialTypes: [],
      },
      //初始值
      show: "false",
      count: "",
      loading: false,
      redirect: undefined,
      rules: {
        userName: [
          {
            required: true,
            trigger: "blur",
            message: "请输入身份证号",
          },
          {
            validator(rule, value, callback) {
              var errorMsg = isIdentityId(value);
              if (errorMsg != "") {
                callback(new Error(errorMsg));
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入密码" },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur",
          },
        ],
        confirmPassword: {
          required: true,
          trigger: "blur",
          message: "请输入密码确认",
        },
        phoneCode: {
          required: true,
          trigger: "blur",
          message: "请输入短信验证码",
        },
        phoneNumber: [
          {
            required: true,
            trigger: "blur",
            message: "请输入手机号",
          },
          {
            validator(rule, value, callback) {
              if (!/^\d{11}$/.test(value)) {
                callback(new Error("请输入合法的手机号"));
              }
              callback();
            },
            trigger: "blur",
          },
        ],
      },
    };
  },

  mounted() {},

  updated() {},

  computed: {},

  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  created() {
  },

  methods: {
    // 注册
    resetPassword() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          var data = {
            userName: this.form.userName,
            password: this.form.password,
            confirmPassword: this.form.confirmPassword,
            phoneNumber: this.form.phoneNumber,
            phoneCode: this.form.phoneCode,
          };
          resetUserPwd(data).then((response) => {
            console.log(response);
            if (response.code == 200) {
              this.reset();
              this.$message({
                message: "重置密码成功",
                type: "success",
              });
            }
          });
        }
      });
    },
    changeType() {
      this.$router.push("/login");
    },
    // 表单重置
    reset() {
      this.form = {
        userName: "",
        password: "",
        confirmPassword: "",
        phoneNumber: "",
        phoneCode: "",
      };
    },
    // 获取短信验证码
    getCode() {
      //axios请求
      console.log(this.form.phoneNumber);
      var phoneReg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if (!phoneReg.test(this.form.phoneNumber)) {
        this.$message({
          message: "请填写合法的手机号码",
          type: "warning",
        });
      } else {
        // 校验手机号码是否对应该身份证号
        checkUserPhone({ userName: this.form.userName, phoneNumber: this.form.phoneNumber }).then((res1) => {
          if (res1.data) {
            // 验证码倒计时
            if (!this.timers) {
              this.count = 60;
              this.show = false;
              this.timers = setInterval(() => {
                if (this.count > 0 && this.count <= 60) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timesr);
                  this.timers = null;
                }
              }, 1000);
            }
            var query = {
              phoneNumber: this.form.phoneNumber,
            };
            sendCode(query).then((res) => {
              if (res.data === "sendSuccess") {
                this.$message({
                  message: "短信已发送",
                  type: "success",
                });
              } else {
                this.$message.error('短信发送失败');
              }
            });
          } else {
            this.$message.error('请确认身份证号或手机号码是否有误');
          }
        });
      }
    },
  }, //methods end
};
</script>

<style scoped lang="less">
.login-backend {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding-top: 200px;
  .login-wrapper {
    width: 400px;
    height: 360px;
    // padding: 20px 10px;
    // box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
    .title {
      margin: 0px auto 30px auto;
      text-align: center;
      color: #707070;
    }
    .text-input {
      margin-bottom: 12px;
    }
    .login-button {
      margin-top: 30px;
      margin-bottom: 20px;
      width: 100%;
    }
    .divider {
      margin-top: 10px;
      .line {
        width: 50px;
        border-top: 1px solid #878787;
      }
      .txt {
        margin: 0 10px;
        color: #878787;
        font-size: 14px;
        font-family: Helvetica Neue;
        line-height: 1.5;
      }
    }
    .other-account {
      .account-icon {
        width: 60px;
      }
    }
    .login-tip {
      margin-top: 30px;
      float: right;
      cursor: pointer;
    }
  }

  .gzh-img{
    display: flex;
    align-content: center;
    justify-content: center;
  }

  .step-container {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    font-size: 16px;
    line-height: 2;
    color: #707070;
  }

  .register {
    align-content: center;
    justify-content: center;
    font-size: 14px;
    line-height: 1.5;
    color: #707070;
  }

  .register-step {
    margin-top: -80px;
    margin-bottom: 20px;
    width: 800px;
  }
  // 注册
  .register-wrapper {
    width: 800px;
    //height: 460px;
    // padding: 20px 10px;
    // box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
    .title {
      margin: 0px auto 30px auto;
      text-align: center;
      color: #707070;
    }
    .text-input {
      margin-bottom: 10px;
    }
    .login-button {
      margin-top: 30px;
      margin-bottom: 20px;
      width: 80%;
      margin-left: 72px;
    }
    .divider {
      margin-top: 10px;
      .line {
        width: 50px;
        border-top: 1px solid #878787;
      }
      .txt {
        margin: 0 10px;
        color: #878787;
        font-size: 14px;
        font-family: Helvetica Neue;
        line-height: 1.5;
      }
    }
    .login-tip {
      margin-top: 50px;
      float: right;
      cursor: pointer;
    }
    em {
      color: red;
      margin-right: 5px;
    }
  }

  // 短信验证码
  .pr {
    position: relative;
  }

  .code-btn {
    width: 100px;
    height: 20px;
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 222;
    //#ef8466橘色
    color: @main-color;
    font-size: 14px;
    border: none;
    border-left: 1px solid #bababa;
    padding-left: 10px;
    background-color: #fff;
    //鼠标指针的样式:伸出食指的手,default 箭头，crosshair 十字，progress 箭头和沙漏
    cursor: pointer;
  }
}

.login-backend-mobile {
  display: flex;
  flex-direction: row;
  align-content: stretch;
  justify-content: left;
  width: 100%;
  height: 100%;
  padding-top: 200px;
  .login-wrapper {
    width: 400px;
    height: 360px;
    // padding: 20px 10px;
    // box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
    .title {
      margin: 0px auto 30px auto;
      text-align: center;
      color: #707070;
    }
    .text-input {
      margin-bottom: 12px;
    }
    .login-button {
      margin-top: 30px;
      margin-bottom: 20px;
      width: 100%;
    }
    .divider {
      margin-top: 10px;
      .line {
        width: 50px;
        border-top: 1px solid #878787;
      }
      .txt {
        margin: 0 10px;
        color: #878787;
        font-size: 14px;
        font-family: Helvetica Neue;
        line-height: 1.5;
      }
    }
    .other-account {
      .account-icon {
        width: 60px;
      }
    }
    .login-tip {
      margin-top: 50px;
      float: right;
      cursor: pointer;
    }
  }

  .gzh-img{
    display: flex;
    align-content: center;
    justify-content: center;
  }

  .step-container {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    font-size: 16px;
    line-height: 2;
    color: #707070;
  }

  .register {
    align-content: center;
    justify-content: center;
    font-size: 14px;
    line-height: 1.5;
    color: #707070;
  }

  .register-step {
    margin-top: -80px;
    margin-bottom: 20px;
  }
  // 注册
  .register-wrapper {
    //height: 460px;
    // padding: 20px 10px;
    // box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
    .title {
      margin: 0px auto 30px auto;
      text-align: center;
      color: #707070;
    }
    .text-input {
      margin-bottom: 10px;
    }
    .login-button {
      margin-top: 30px;
      width: 80%;
      margin-left: 72px;
    }
    .divider {
      margin-top: 10px;
      .line {
        width: 50px;
        border-top: 1px solid #878787;
      }
      .txt {
        margin: 0 10px;
        color: #878787;
        font-size: 14px;
        font-family: Helvetica Neue;
        line-height: 1.5;
      }
    }
    .login-tip {
      margin-top: 10px;
      float: right;
      cursor: pointer;
    }
    em {
      color: red;
      margin-right: 5px;
    }
  }

  // 短信验证码
  .pr {
    position: relative;
  }

  .code-btn {
    width: 100px;
    height: 20px;
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 222;
    //#ef8466橘色
    color: @main-color;
    font-size: 14px;
    border: none;
    border-left: 1px solid #bababa;
    padding-left: 10px;
    background-color: #fff;
    //鼠标指针的样式:伸出食指的手,default 箭头，crosshair 十字，progress 箭头和沙漏
    cursor: pointer;
  }
}
</style>
